
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining/news/[id]",
      function () {
        return require("private-next-pages/dining/news/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining/news/[id]"])
      });
    }
  